/**
 * « En attendant… » — les pauses proposées quand aucune question du défi ne
 * correspond à l'élève. Du contenu léger, qui change rarement : il reste dans
 * l'app. Les questions du défi, elles, arrivent du backend avec l'envoi de la
 * copie.
 */

// Virelangues à lire à voix haute — aucune bonne réponse, juste pour s'amuser.
export const VIRELANGUES = [
    "Les chaussettes de l'archiduchesse sont-elles sèches, archi-sèches ?",
    "Un chasseur sachant chasser doit savoir chasser sans son chien.",
    "Les vers verts levèrent le verre vert vers le ver vert.",
    "Ton thé t'a-t-il ôté ta toux ?",
    "Trois tortues trottaient sur trois toits très étroits.",
    "Si six scies scient six cyprès, six cent scies scient six cent cyprès.",
    "Didon dîna, dit-on, du dos d'un dodu dindon.",
    "Cinq chiens chassent six chats.",
    "Piano panier, piano panier, piano panier…",
    "Natacha n'attacha pas son chat Pacha qui s'échappa.",
    "Un dragon gradé dégrade un gradé dragon.",
    "Je veux et j'exige d'exquises excuses.",
    "Fruits frais, fruits frits, fruits cuits, fruits crus.",
    "Trois gros rats gris dans trois gros trous ronds rongent.",
    "Douze douches douces.",
    "Seize chaises sèchent.",
    "Six saucissons secs sous six sacs.",
    "Le ver vert va vers le verre vert.",
    "Suis-je bien chez ce cher Serge ?",
    "Poisson sans boisson, c'est poison !",
]

// Anecdotes, blagues et citations — à lire, zéro effort. `emoji` + `label`
// donnent le ton, `text` supporte du gras via des segments `**…**` rendus par
// le composant.
export const FACTS = [
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "Le mot **bonjour** vient de « bon » + « jour » : souhaiter une bonne journée existe depuis le Moyen Âge !",
    },
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "Une **année-lumière** ne mesure pas le temps mais une distance : environ **9 500 milliards de km**.",
    },
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "Le **cœur** d'un humain bat environ **100 000 fois par jour** sans jamais s'arrêter.",
    },
    {
        emoji: "😄",
        label: "Blague du jour",
        text: "Que dit un citron quand il a mal ? — « J'ai le **zeste** en compote. »",
    },
    {
        emoji: "😄",
        label: "Blague du jour",
        text: "Pourquoi les maths sont tristes ? — Parce qu'elles ont trop de **problèmes**.",
    },
    {
        emoji: "😄",
        label: "Blague du jour",
        text: "Quel est le comble pour un électricien ? — De ne pas être **au courant**.",
    },
    {
        emoji: "✨",
        label: "Citation",
        text: "« Le succès, c'est tomber sept fois et se relever **huit**. » — Proverbe japonais",
    },
    {
        emoji: "✨",
        label: "Citation",
        text: "« On ne fait bien que ce qu'on fait **avec plaisir**. » — Jean Anthelme Brillat-Savarin",
    },
    {
        emoji: "🌍",
        label: "Info générale",
        text: "Le **Nil** et l'**Amazone** se disputent le titre du plus long fleuve du monde : environ **6 700 km** chacun.",
    },
    {
        emoji: "🌍",
        label: "Info générale",
        text: "Il y a plus d'**étoiles** dans l'univers observable que de **grains de sable** sur toutes les plages de la Terre.",
    },
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "Un **poulpe** a **trois cœurs** et du sang bleu.",
    },
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "La **lumière** du Soleil met environ **8 minutes** à atteindre la Terre.",
    },
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "Les **flamants roses** naissent gris : leur couleur vient de ce qu'ils mangent !",
    },
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "La **Tour Eiffel** peut grandir d'environ **15 cm** en été : le métal se dilate à la chaleur.",
    },
    {
        emoji: "💡",
        label: "Le savais-tu ?",
        text: "Le **miel** ne se périme jamais : on en a retrouvé de comestible dans des tombes égyptiennes !",
    },
    {
        emoji: "😄",
        label: "Blague du jour",
        text: "Pourquoi les poissons détestent l'ordinateur ? — Ils ont peur du **Net**.",
    },
    {
        emoji: "😄",
        label: "Blague du jour",
        text: "Que dit un océan à un autre océan ? — Rien, ils se font juste des **vagues**.",
    },
    {
        emoji: "😄",
        label: "Blague du jour",
        text: "Quel est le comble pour un jardinier ? — Raconter des **salades**.",
    },
    {
        emoji: "✨",
        label: "Citation",
        text: "« L'imagination est plus importante que le savoir. » — Albert Einstein",
    },
    {
        emoji: "✨",
        label: "Citation",
        text: "« Petit à petit, l'oiseau fait son nid. » — Proverbe",
    },
    {
        emoji: "✨",
        label: "Citation",
        text: "« La curiosité est le plus sûr chemin vers la connaissance. »",
    },
    {
        emoji: "🌍",
        label: "Info générale",
        text: "Le plus grand désert chaud du monde est le **Sahara** ; le plus grand désert tout court est l'**Antarctique**.",
    },
    {
        emoji: "🌍",
        label: "Info générale",
        text: "Le **cœur** d'une baleine bleue pèse presque autant qu'une petite voiture.",
    },
    {
        emoji: "🌍",
        label: "Info générale",
        text: "La **Grande Muraille de Chine** mesure plus de **20 000 km** de long.",
    },
]
